var Data = {
  stats: {
    result: null,
    error: "",
    fetch: (options={}) => {
      m.request({
        method: "GET",
        url: "/data/",
      }).then((items) => {
        Data.stats.result = items
      }).catch((e) => {
        Data.stats.error = e.message
      })
    }
  }
}

export { Data }
